function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDateCompletedi = function SvgDateCompletedi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m11.618 17.51 3.94 4.002a.697.697 0 0 0 1.07-.091l4.75-6.838c.22-.317.15-.754-.17-.974s-.76-.142-.98.175l-4.26 6.144-3.35-3.399a.7.7 0 0 0-.99-.009.716.716 0 0 0-.01.99m4.6-13.521h-3.59V3a.7.7 0 0 0-.7-.7c-.38 0-.7.314-.7.7v.989h-3.46V3a.7.7 0 1 0-1.4 0v.989h-2.4c-.93 0-1.7.762-1.7 1.7V20c0 .939.77 1.7 1.7 1.7h8.02a.7.7 0 1 0 0-1.4h-8.02c-.16 0-.3-.134-.3-.3v-9.876h16.64v1.133a.7.7 0 1 0 1.4 0V5.689a1.7 1.7 0 0 0-1.7-1.7h-2.39V3c0-.386-.32-.7-.71-.7-.38 0-.69.314-.69.7zm1.4 1.4v.989c0 .386-.32.7-.71.7a.696.696 0 0 1-.69-.7v-.989h-3.59v.989a.7.7 0 0 1-.7.7c-.38 0-.7-.314-.7-.7v-.989h-3.46v.989a.7.7 0 1 1-1.4 0v-.989h-2.4c-.16 0-.3.135-.3.3v3.035h16.64V5.689c0-.165-.13-.3-.3-.3z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDateCompletedi);
export default ForwardRef;